module.exports = __webpack_public_path__ + "img/portal-terms.be459ebc.jpg";